import React, { PropsWithChildren, useEffect } from 'react'
import { compose } from 'recompose'

import { generateRoute } from 'utils/routing'

import { withRouter, withRouterProps } from 'services/router'

type ChildEditWrapperProps = PropsWithChildren & withRouterProps

const ChildEditWrapper: React.FC<ChildEditWrapperProps> = ({ children, location, navigate, params }) => {
  const { pathname } = location

  useEffect(() => {
    if (generateRoute('CHILDREN.CHILD_EDIT', { childId: params.childId }) === pathname) {
      navigate(generateRoute('CHILDREN.CHILD', { childId: params.childId }))
    }
  }, [pathname])

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <React.Fragment>
      {children}
    </React.Fragment>
  )
}

const enhance = compose(
  withRouter,
)

export default enhance(ChildEditWrapper)
